import { initSocialLogin } from './sessions';
import { t } from '../utils/translate';

const errorMessage = function(error) {
  if (error.field[0] && error.field[0].name === 'terms_sign_up') {
    return 'You must agree to the terms and conditions';
  }
  if (error.name === 'required') {
    return t('field_required');
  }
  if (error.name === 'email') {
    return t('must_be_valid_email');
  }
  if (error.name === 'no_email') {
    return t('cannot_be_email');
  }
  if (error.name === 'url') {
    return t('must_be_valid_url');
  }
  if (error.name === 'tel') {
    return 'Must be a valid phone number';
  }
  if (error.name === 'unique_email') {
    return t('email_taken');
  }
  if (error.name === 'unique_subdomain') {
    return t('subdomain_taken');
  }
  if (error.name === 'checking_email') {
    return t('checking_email');
  }
  if (error.name === 'checking_subdomain') {
    return t('checking_subdomain');
  }
  if (error.name === 'match_password') {
    return t('match_password');
  }
  if (error.name === 'requiredSingleSelect') {
    return t('must_choose_one');
  }
  if (error.name === 'requiredMultipleChoice') {
    return t('must_choose_at_least_one');
  }
  if (error.name === 'requiredMatrix') {
    return t('must_make_one_entry_per_row');
  }
  if (error.name === 'requiredOpenMatrix') {
    return t('must_fill_all');
  }
  if (error.name === 'constantSum') {
    return t('constant_sum_no_match');
  }
  if (error.name === 'constantSumOther') {
    return t('constant_sum_other_required');
  }
  if (error.name === 'otherVerbatim') {
    return t('otherVerbatim');
  }
  if (error.name === 'usZipcode') {
    return 'Invalid zip code';
  }
  return t('general_validation_error');
};

// Inject error messages for yafov validations
// Set is_message to true if this is just a message and you
// don't want to add red error styling to the field
export function buildErrorMessage(error, is_message) {
  if (error.name === '') {
    return false;
  }

  const chooseIcon = function() {
    if (error.type && error.type === 'ajax') {
      return '<span class="icon icon_ajax"></span> ';
    }
    return '<span class="icon icon_warning"></span>';
  };

  const $msg = $('<label>', { for: error.field[0].id }).addClass(
    'fs-12 mv2 d-b'
  );
  const icon = chooseIcon();
  const $field = $(error.field);
  is_message = is_message != null ? is_message : false; // is_message defauts to false

  if (error.type && error.type === 'ajax') {
    $msg.addClass('ajax_message');
  } else {
    $msg.addClass('error_message c-red');
  }
  $msg.html(errorMessage(error));
  $msg.prepend(icon);

  // Remove previous error message
  $field
    .closest('.field')
    .find('.error_message, .ajax_message')
    .remove();

  // Add error styling unless this is just a message
  if (!is_message) {
    $field
      .closest('.field')
      .addClass('field_with_errors')
      .removeClass('valid_field');
  }

  // Insert error message
  const parent = $field.closest('.field');
  const label = parent.find('.srv-q-t');
  if (label.length > 0) {
    return label.after($msg);
  } else {
    return parent.append($msg);
  }
}

// Hide error messages for yafov validations
export function removeErrorMessage(error) {
  const $field = $(error.field);
  $field.closest('.field_with_errors').removeClass('field_with_errors');
  $field.closest('.field').addClass('valid_field');
  return $field
    .closest('.field')
    .find('.error_message, .ajax_message')
    .remove();
}

//
//  Custom validation method for a 'required' group of checkboxes or radios
//  This will require that one of the options be checked
//
// This is the validator method, it take a group of elements and compares them
const requiredChooseOneOrManyValidator = function(value, elements, callback) {
  // Presume invalid
  let valid = false;

  // If at least one of the group is checked, then we're valid
  elements.each(function() {
    if (this.type === 'checkbox' || this.type === 'radio' || this.type == 'slider') {
      valid = this.checked;
    } else {
      valid = this.value !== '';
    }

    if (valid) {
      return false;
    }
  });

  return callback(valid);
};

// This method collects all the inputs in the group
const requiredChooseOneOrManyGetGroup = function(el) {
  const wrapper = el.closest('.field');
  const elements = wrapper.find('input, select');
  return elements;
};

const requiredMultiPartValidator = function(value, elements, callback) {
  // Presume valid
  let valid = true;

  // All the required fields must be filled
  elements.each(function(e, el) {
    if ($(el).val() === '') {
      valid = false;
    }
    if (!valid) {
      return false;
    }
  });

  return callback(valid);
};

const requiredMultiPartGetGroup = el =>
  el.closest('.field').find('input[required], select[required]');

//
//  Constant Sum Validation
//  Sum of each field's value must equal the target value
//  Or, each field must be blank
//
const constantSumValidator = function(value, elements, callback) {
  const allBlank = ICMIB.surveys.isConstantSumBlank(elements);
  const isNone = ICMIB.surveys.isConstantSumNoneOfTheAbove(elements);
  const target = ICMIB.surveys.getConstantSumTarget(elements);
  const sum = Array.from(elements).reduce(ICMIB.surveys.reduceConstantSum, 0);
  const valid = allBlank || isNone || target === sum;
  return callback(valid);
};

const constantSumGetGroup = el =>
  el.closest('.field').find('.constant-sum__input');

//
// Constant sum with other
//
const constantSumOtherValidator = function(value, elements, callback) {
  const otherName = $.trim(elements.not('.constant-sum__input').val());
  const otherVal = $.trim(elements.filter('.constant-sum__input').val());
  const isNone = ICMIB.surveys.isConstantSumNoneOfTheAbove(elements);
  const valid =
    !!otherVal.length === !!otherName.length || isNone || +otherVal === 0;
  return callback(valid);
};

const constantSumOtherGetGroup = el => el.closest('.other_row').find('input');

//
// Require Other verbatims
// If Other row is selected force text entry. If Other row is deselected
// force no text.
//
const otherVerbatimValidator = function(value, els, cb) {
  const filled = !!$.trim(els.filter('[type=text]').val()).length;
  const checked = els.is('select')
    ? !!els.filter('select').val().length
    : els.is(':checked');
  const valid = checked === filled;
  return cb(valid);
};

const otherVerbatimGetGroup = el =>
  el.closest('.chc_othr').find('input, select');

let BACKOFF = 100;

// Initialize user registration validation
export function initUserRegistrationValidation(el) {
  // Use the same xhr object for each email check
  if (!$.yafov) {
    return setTimeout(() => {
      BACKOFF = BACKOFF * 2;
      initUserRegistrationValidation(el);
    }, BACKOFF);
  }

  addYafovMethods();

  // validation
  if (el == null) {
    el = '#user_new, #new_user';
  }
  const user_validator = $(el).yafov();

  //field is invalid
  user_validator.bind('invalidfound', (e, error) =>
    ICMIB.buildErrorMessage(error)
  );

  // field is valid
  user_validator.bind('validfound', (e, error) => {
    $('#sign_up_submit').prop('disabled', false);
    ICMIB.removeErrorMessage(error);
  });

  // Submit for if everything is valid
  user_validator.bind('formvalid', function() {
    return this.submit();
  });

  // Password matching
  const matchPasswords = function(e) {
    if ($('.user_password_confirmation').val() === '') {
      return true;
    }

    const result = {
      field: $('.user_password_confirmation'),
      isGroup: false,
      name: 'match_password',
    };

    if ($('.reg_password').val() === $('.user_password_confirmation').val()) {
      result.isValid = true;
      $('.user_password_confirmation').trigger('validfound', result);
    } else {
      result.isValid = false;
      if (e.type === 'submit') {
        e.preventDefault();
      }
      $('.user_password_confirmation').trigger('invalidfound', result);
    }

    if (!result.isValid) {
      e.preventDefault();
    }
    return result.isValid;
  };

  $('.reg_password, .user_password_confirmation').blur(matchPasswords);
  return $(el).submit(matchPasswords);
}

function addYafovMethods() {
  $.yafov.addGroupMethod(
    '.has_other:not(.constant_sum) .chc_othr input',
    'otherVerbatim',
    otherVerbatimValidator,
    otherVerbatimGetGroup
  );

  // Custom validation method to ensure uniqueness of subdomain
  $.yafov.addMethod('.unique_subdomain', '.unique_subdomain', function(
    value,
    element,
    cb
  ) {
    ICMIB.unique_subdomain_xhr.abort(); // Cancel previous requests, esp since it sometimes fires twice
    const $field = $(element)
      .closest('.field')
      .removeClass('field_with_errors valid_field');
    ICMIB.buildErrorMessage(
      {
        field: element,
        name: 'checking_subdomain',
        type: 'ajax',
      },
      true
    );

    return (ICMIB.unique_subdomain_xhr = $.ajax({
      url: $(element).data('unique-subdomain-url'),
      data: `subdomain=${encodeURIComponent(value)}`,
      complete() {
        return $field.removeClass('working');
      },
      success(response) {
        // call the callback function, pass to it that is the field is valid or no
        if (response.success) {
          return cb(true);
        } else {
          return cb(false);
        }
      },
    }));
  });

  // Custom validation method to disallow emails as names for users
  $.yafov.addMethod('.no_email', 'no_email', (value, element, cb) =>
    cb(!value.match(/@/))
  );

  $.yafov.addGroupMethod(
    '.required.single_select:not(.matrix) input, .required.single_select:not(.matrix) select', // selector
    'requiredSingleSelect', // event name
    requiredChooseOneOrManyValidator,
    requiredChooseOneOrManyGetGroup
  );
  $.yafov.addGroupMethod(
    '.required.multiple_select:not(.matrix) input', // selector
    'requiredMultipleChoice', // event name
    requiredChooseOneOrManyValidator,
    requiredChooseOneOrManyGetGroup
  );

  $.yafov.addGroupMethod(
    '.required.multi_part input, .required.multi_part select', // selector
    'requiredMultiPart', // event name
    requiredMultiPartValidator,
    requiredMultiPartGetGroup
  );

  $.yafov.addGroupMethod(
    '.constant_sum input', // selector
    'constantSum', // event name
    constantSumValidator,
    constantSumGetGroup
  );

  $.yafov.addGroupMethod(
    '.constant_sum .other_row input', // selector
    'constantSumOther', // event name
    constantSumOtherValidator,
    constantSumOtherGetGroup
  );

  //
  //  Required matrix validations
  //  Enforces one entry per row
  //
  $.yafov.addGroupMethod(
    `.required.matrix input[type=checkbox], \
.required.matrix input[type=radio], \
.required.matrix select`, // selector
    'requiredMatrix', // event name

    // validate!
    function(value, elements, callback) {
      // Presume valid
      let valid = true;

      // If each row has at least one entry, remain valid
      // If any row is invalid, the whole question is invalid
      elements.each(function() {
        const $row = $(this);
        let row_valid = false; // Presume this row is invalid

        $row
          .find(':checkbox, :radio, select')
          .not('input:hidden')
          .each(function() {
            // If this is the Other row, skip it
            if ($row.hasClass('other_row')) {
              return false;
            }
            // If this is a Why? field, this row is valid
            if ($row.hasClass('why_row')) {
              row_valid = true;
              return false;
            }

            // If any of the inputs in this row has a value, this row is valid
            if (this.type === 'checkbox' || this.type === 'radio' || this.type == 'slider') {
              row_valid = this.checked;
            } else {
              row_valid = $(this).val() !== '';
            }

            // If we found a value, go ahead and exit this row
            if (row_valid) {
              return false;
            }
          });

        // If this row remained invalid, the whole question is invalid
        if (!row_valid) {
          valid = false;
          return false;
        }
      });

      return callback(valid);
    },
    // Collect each row
    function(el) {
      const wrapper = el.closest('.field');
      return wrapper.find('tbody tr').not('.other_row, .why_row');
    }
  );

  //
  //  Required open matrix validations
  //  Enforces all fields
  //
  $.yafov.addGroupMethod(
    `.required.matrix.open input, \
.required.constant_sum input`, // selector
    'requiredOpenMatrix', // event name

    // validate!
    function(value, elements, callback) {
      // Presume valid
      let valid = true;

      // If any field is empty, question is invalid
      // Else remain valid
      elements.each(function() {
        const $row = $(this);
        let row_valid = true; // Presume this row is valid

        $row
          .find('input, textarea')
          .not('input:hidden, :checkbox, :radio, :file, .srv-q-why-essay')
          .each(function() {
            // If this is the Other row, skip it
            if ($row.hasClass('other_row')) {
              return false;
            }

            // If this is a Why? field, skip it
            if ($row.hasClass('why_row')) {
              return false;
            }

            const $field = $(this);

            row_valid = $field.val() !== '';

            // If a single field is blank go ahead and exit
            if (!row_valid) {
              return false;
            }
          });

        // If this row remained invalid, the whole question is invalid
        if (!row_valid) {
          valid = false;
          return false;
        }
      });

      return callback(valid);
    },
    // Collect each row
    function(el) {
      const wrapper = el.closest('.field');
      return wrapper.find('tbody tr').not('.other_row, .why_row');
    }
  );
}
